var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { render } from 'react-dom';
import { OuraConsentManager } from './index';
export var init = function () {
    if (!window.OURA_CONSENT_MANAGER.segmentKey) {
        throw new Error('window.OURA_CONSENT_MANAGER.segmentKey must be set before loading the Consent Manager.');
    }
    render(_jsx(OuraConsentManager, __assign({}, window.OURA_CONSENT_MANAGER)), document.querySelector('#oura-consent-manager'));
};
init();
